import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
//for pagination kauhsalya(2017-07-31)
import {NgxPaginationModule} from 'ngx-pagination';

import { MyDatePickerModule } from 'mydatepicker';
import { TranslateModule } from 'ng2-translate';
import { TooltipModule } from 'ng2-tooltip';
import { DndModule } from 'ng2-dnd';
import { Ng2DragDropModule } from "ng2-drag-drop";
import { ChartsModule } from 'ng2-charts';
import { DragulaModule } from 'ng2-dragula';
import { TinymceModule } from 'angular2-tinymce';
import { ContextMenuModule } from 'angular2-contextmenu';


import { InlineEditorModule } from '../../shared/modules/inline-editor/inline-editor.module';
import { PipeCapitalizeModule } from '../../shared/modules/pipe-capitalize/pipe-capitalize.module';
import { ModalLoginAgainModule } from '../../shared/modules/modal-login-again/modal-login-again.module';
import { ConfirmationModule } from '../../shared/modules/confirmation/confirmation.module';

import { WorkMainComponent } from "./components/work-main.component";
import { ProjectsComponent } from "./components/projects.component";
import { ProjectdetailsComponent } from './components/projectdetails.component';
import { ObjectPipe } from './pipes/object.pipe';
import { DocumentComponent } from './modal/document.component';
import { TimeLineComponent } from './modal/time-line/time-line.component';

import { IssueCreaterModule } from '../issues/shared/issue-creater/issue-creater.module';
import { ModalTaskModule } from './modal/modal-task/modal-task.module';
import { TimeSheetModule } from './modal/time-sheet/time-sheet.module';

import { SprintComponent } from './components/sprint.component';

import { ModalComponentAssignComponent } from './modal/modal-component-assign.component';
import { ModalDeleteVersionComponent } from './modal/modal-delete-version.component';
import { ModalStoryComponent } from './modal/modal-story.component';
import { ModalSprintCreateComponent } from './modal/modal-sprint-create.component';
import { ModalModuleComponent } from './modal/modal-module.component';
import { ConfirmationToolboxComponent } from './modal/confirmation-toolbox.component';

import { workRoutingProviders } from './work.routes';

import { mainRouting } from '../main.routes';
import { ModalStoryViewComponent } from './modal/modal-story-view/modal-story-view.component';
import { ProjectSprintComponent } from './components/project-sprint/project-sprint.component';
import { ProjectIssuesComponent } from './components/project-issues/project-issues.component';

@NgModule({
  declarations: [
    WorkMainComponent,
    ProjectsComponent,
    ProjectdetailsComponent,
    SprintComponent,
    ModalStoryComponent,
    ModalComponentAssignComponent,
    ModalDeleteVersionComponent,
    ModalSprintCreateComponent,
    ConfirmationToolboxComponent,
    ObjectPipe,
    DocumentComponent,
    ModalModuleComponent,
    TimeLineComponent,
    ModalStoryViewComponent,
    ProjectSprintComponent,
    ProjectIssuesComponent
  ],
  imports: [
    CommonModule,
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    NgxPaginationModule,
    MyDatePickerModule,
    TooltipModule,
    TranslateModule,
    Ng2DragDropModule,
    ChartsModule,
    ModalTaskModule,
    TimeSheetModule,
    DndModule.forRoot(),
    DragulaModule,
    TinymceModule.withConfig({ menubar: false }),

    InlineEditorModule,
    PipeCapitalizeModule,
    ModalLoginAgainModule,
    ConfirmationModule,
    IssueCreaterModule,

    ContextMenuModule,

    mainRouting
  ],
  providers: [workRoutingProviders]
})
export class WorkModule { }



// WEBPACK FOOTER //
// ./src/app/modules/work/work.module.ts